'use client'

import { api, getCachedSession } from '@/shared/api/client-api'
import { API_END_POINTS } from '@/shared/api/end-points'
import { methods } from '@/shared/api/constants'
import { CreateUploadedFileDto, CreateUploadedFileResponse } from '../../lib'

const createUploadedFile = async (dto: CreateUploadedFileDto) => {
  const session = await getCachedSession()
  const userId = dto.userId ?? session?.user?.data?.id

  const payload = {
    ...dto,
    projectId: Number(dto.projectId),
    userId,
  }

  const res = await api.json<CreateUploadedFileResponse>(API_END_POINTS.uploadedFile.createUploadedFile, {
    method: methods.post,
    body: JSON.stringify(payload),
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (res.ok) {
    return res.result
  }

  throw new Error(res?.message || res?.error)
}

export default createUploadedFile
